var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMasterIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.75,
    cy: 9.5,
    r: 9.5,
    fill: "#E3F2FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.27344 9.34906H9.02628",
    stroke: "#1976D2",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.27344 11.849H12.9572",
    stroke: "#1976D2",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.27344 14.3491H12.9572",
    stroke: "#1976D2",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.27344 16.849H9.27344",
    stroke: "#1976D2",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7997 9.5751H12.0313C11.7152 9.5751 11.459 9.31885 11.459 9.00276V6.23439",
    stroke: "#1976D2",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4109 20.173C12.6462 20.173 12.0262 19.5531 12.0262 18.7883C12.0262 18.0236 12.6462 17.4037 13.4109 17.4037C14.1757 17.4037 14.7956 18.0236 14.7956 18.7883C14.7956 19.5531 14.1757 20.173 13.4109 20.173ZM16.0226 18.2622C15.8659 18.2622 15.7271 18.1623 15.6764 18.0141C15.6437 17.9181 15.6049 17.8248 15.5607 17.7348C15.4915 17.5938 15.5186 17.4247 15.6296 17.3137L15.6297 17.3136C15.7724 17.1708 15.7724 16.9393 15.6297 16.7965L15.4027 16.5696C15.2599 16.4268 15.0284 16.4268 14.8856 16.5696L14.8856 16.5697C14.7746 16.6807 14.6054 16.7077 14.4644 16.6385C14.3744 16.5943 14.2812 16.5556 14.1852 16.5228C14.0369 16.4722 13.937 16.3333 13.937 16.1767C13.937 15.9747 13.7733 15.811 13.5714 15.811H13.2504C13.0485 15.811 12.8848 15.9747 12.8848 16.1767C12.8848 16.3333 12.7849 16.4722 12.6367 16.5228C12.5407 16.5556 12.4474 16.5943 12.3574 16.6385C12.2164 16.7077 12.0472 16.6807 11.9363 16.5697L11.9362 16.5696C11.7934 16.4268 11.5619 16.4268 11.4191 16.5696L11.1922 16.7965C11.0494 16.9393 11.0494 17.1708 11.1922 17.3136L11.1922 17.3137C11.3032 17.4247 11.3303 17.5938 11.2611 17.7348C11.2169 17.8248 11.1782 17.9181 11.1454 18.0141C11.0947 18.1623 10.9558 18.2622 10.7992 18.2622C10.5973 18.2622 10.4336 18.4259 10.4336 18.6279V18.9488C10.4336 19.1507 10.5973 19.3144 10.7992 19.3144C10.9558 19.3144 11.0947 19.4144 11.1454 19.5626C11.1782 19.6586 11.2169 19.7518 11.2611 19.8418C11.3303 19.9828 11.3032 20.152 11.1922 20.263L11.1922 20.2631C11.0494 20.4058 11.0494 20.6373 11.1922 20.7802L11.4191 21.0071C11.5619 21.1499 11.7934 21.1499 11.9362 21.0071L11.9363 21.007C12.0472 20.896 12.2164 20.869 12.3574 20.9382C12.4474 20.9824 12.5407 21.0211 12.6367 21.0539C12.7849 21.1045 12.8848 21.2434 12.8848 21.4C12.8848 21.602 13.0485 21.7657 13.2504 21.7657H13.5714C13.7733 21.7657 13.937 21.602 13.937 21.4C13.937 21.2434 14.0369 21.1045 14.1852 21.0539C14.2812 21.0211 14.3744 20.9824 14.4644 20.9382C14.6054 20.869 14.7746 20.896 14.8856 21.007L14.8856 21.0071C15.0284 21.1499 15.2599 21.1499 15.4027 21.0071L15.6297 20.7802C15.7724 20.6373 15.7724 20.4058 15.6297 20.2631L15.6296 20.263C15.5186 20.152 15.4915 19.9828 15.5607 19.8418C15.6049 19.7518 15.6437 19.6586 15.6764 19.5626C15.7271 19.4144 15.8659 19.3144 16.0226 19.3144C16.2245 19.3144 16.3882 19.1507 16.3882 18.9488V18.6279C16.3882 18.4259 16.2245 18.2622 16.0226 18.2622Z",
    stroke: "#1976D2",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7988 15.5235V9.57512L11.458 6.23441H4.36886C3.95048 6.23441 3.61133 6.57356 3.61133 6.99191V19.6982C3.61133 20.1166 3.95048 20.4557 4.36886 20.4557H9.86439",
    stroke: "#1976D2",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterIcon);
export default __webpack_public_path__ + "static/media/master_icon.38ec9fb341a0c0aa416b99ee14d29ed1.svg";
export { ForwardRef as ReactComponent };